<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="30"
		height="31"
		viewBox="0 0 30 31"
	>
		<image
			width="30"
			height="31"
			xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAQAAABaZbWMAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfpBw8PFgVwcirJAAABbUlEQVQ4y5WTTUtCQRSGT0V+rIJ+RFBZSoQU0TICP0KjaOEf6Qf0B4KsriHUptZChkpZELQPWrVvZaZmEJnytHDRvXOv9849s5qB533fM3NGyPHMDdtMIX6X8ApAiwIx//B/dTFY9Ae/Ya5PPwJCnAewCUT1YCHELk82gQILOrAgTLDnP4F5EybLoyLQxhidQD0YY4e6ItDl1DmBk2KILeoMlAQOdzC6owxVW4JjInqwECRJnV+LwAd55nTg4UpTVhJ0OBom0JmkAJvUlARNDgjrT3KakpLg0N8/WuPFBDfGRb9mJCXTpn1H13OWExqW0F/kdMAoebpKv9ese9/2PAbvFqxHhQ0mvZ5qCYNvxbFMynvCIhRpWrA+dySGjm5wnDObY4WM96+KcUHLwTHo9SVXKdLTcVThZS7pKI63JAi4vYUgrHBOX3GskfWeAGGftq3HpHOPdthaVbceR8MD7km692iHr4AfSjo9qusPjkWEwxIkZ44AAAAASUVORK5CYII="
		/>
	</svg>
</template>
